// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'rule-library';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M3.96.576h12.384c.648 0 1.152.504 1.152 1.152v12.384c0 .648-.504 1.152-1.152 1.152H3.96a1.137 1.137 0 0 1-1.152-1.152V1.656c0-.576.504-1.08 1.152-1.08z' />
    <path d='M15.192 17.424H1.656a1.137 1.137 0 0 1-1.152-1.152V2.808m4.968.864h4.104M5.472 6.336h4.104M5.472 8.928h4.104m-4.104 2.664h4.104m2.664-1.008 1.08 1.512 1.152-1.512m-2.232-5.76 1.08-1.512 1.152 1.512' />
  </g>
);

export const viewBox = '0 0 18 18';
